import * as React from "react";
import { getElementXId, getElementYId } from "./utils";
import { hexColor } from "./helpers/colorParser";
import memoize from "memoize-one";
import { getElementZId } from "./utils";
export default class HistogramBars extends React.PureComponent {
    render() {
        const { elements, clipId } = this.props;
        return (React.createElement("g", { clipPath: `url(#${clipId})` }, elements.map((element, index) => (React.createElement(HistogramBar, Object.assign({ key: `${index}` }, this.props, { element: element }))))));
    }
}
class HistogramBar extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.hexColorMem = memoize(hexColor);
    }
    render() {
        const { element, data, xScale, yScale, ignoreFileName } = this.props;
        const barsElement = element;
        const xId = getElementXId(barsElement, ignoreFileName);
        const yId = getElementYId(barsElement, ignoreFileName);
        const zId = getElementZId(barsElement, ignoreFileName);
        const bars = data.data[xId].map((xValue, index) => ({
            x: xScale(xValue) - (xScale(data.data[zId][index]) - xScale(0)),
            y: yScale(data.data[yId][index]),
            height: yScale(0) - yScale(data.data[yId][index]),
            width: 2.0 * (xScale(data.data[zId][index]) - xScale(0)),
            color: this.hexColorMem(barsElement.symbolColor),
        }));
        return (React.createElement(React.Fragment, null, bars.map((bar, index) => (React.createElement("rect", { key: `${index}`, x: `${bar.x}`, y: `${bar.y}`, fillOpacity: "0.6", width: `${bar.width}`, height: `${bar.height}`, fill: `${bar.color}` })))));
    }
}
//# sourceMappingURL=HistogramBars.js.map